import { Injectable } from "@angular/core";
import { Model_Workflow } from 'src/app/app.models';
import { PlatformResult, API_RESULT_STATUS } from '../../platform/platform.service';
import { WorkflowOfflineDao } from './workflow-offline.dao';

export interface WorkflowApi {
    doSyncWorkflowsAction(workflowsRaw: string);
    onWorkflowsSynced(_result: PlatformResult);

    doClearWorkflowsAction();
    onWorkflowsCleared(_result: PlatformResult);

    doGetWorkflowsAction();
    onWorkflowsFetched(_result: PlatformResult);

    doInsertWorkflowsAction(workflowsRaw: string);
    onWorkflowsInserted(_result: PlatformResult);

    doSaveWorkflowAction(workflowsRaw: string);
    onWorkflowSaved(result: PlatformResult);

    doGetWorkflowAction(numWorkflow: string);
    onWorkflowFetched(result: PlatformResult);
}

@Injectable()
export class WorkflowOfflineAndroidDao extends WorkflowOfflineDao {
    doSyncWorkflowsAction(_workflows: Model_Workflow[]): Promise<void> {
        return new Promise((resolve, reject) => {
            window['WorkflowApi'].onWorkflowsSynced = (_result: PlatformResult) => {
                delete window['WorkflowApi'].onWorkflowsSynced;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const workflowApi: WorkflowApi = window['WorkflowApi'];
            workflowApi.doSyncWorkflowsAction(JSON.stringify(_workflows))
        });
    }

    doClearWorkflowsAction() {
        return new Promise<void>((resolve, reject) => {
            window['WorkflowApi'].onWorkflowsCleared = (_result: PlatformResult) => {
                delete window['WorkflowApi'].onWorkflowsCleared;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const workflowApi: WorkflowApi = window['WorkflowApi'];
            workflowApi.doClearWorkflowsAction()
        });
    }

    doGetWorkflowsAction(): Promise<Model_Workflow[]> {
        return new Promise<Model_Workflow[]>((resolve, reject) => {
            window['WorkflowApi'].onWorkflowsFetched = (_result: PlatformResult) => {
                delete window['WorkflowApi'].onWorkflowsFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const workflowApi: WorkflowApi = window['WorkflowApi'];
            workflowApi.doGetWorkflowsAction()
        });
    }

    doInsertWorkflowsAction(_workflows: Model_Workflow[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            window['WorkflowApi'].onWorkflowsInserted = (_result: PlatformResult) => {
                delete window['WorkflowApi'].onWorkflowsInserted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowApi: WorkflowApi = window['WorkflowApi'];
            responseWorkflowApi.doInsertWorkflowsAction(JSON.stringify(_workflows));
        });
    }

    doGetWorkflowAction(_numWorkflow: string): Promise<Model_Workflow> {
        return new Promise((resolve, reject) => {
            window['WorkflowApi'].onWorkflowFetched = (_result: PlatformResult) => {
                delete window['WorkflowApi'].onWorkflowFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const workflow: WorkflowApi = window['WorkflowApi'];
            workflow.doGetWorkflowAction(_numWorkflow);
        });
    }
}
